import React from 'react';
import MuiGrid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { HTMLPrinterProps } from '../../../services/Main/types.Component';
import Header from '../../lowLevel/Header';
import HTMLPrinterActionsComponent from '../../lowLevel/HTMLPrinterActions';
import useStyles from './HTMLPrinter.styles';
import Alerts from '../../lowLevel/Alerts';

const HTMLPrinter = ({ html, header, actions, alerts }: HTMLPrinterProps) => {
  const classes = useStyles();

  return (
    <div>
      {header && (
        <Box className={classes.headerContainer}>
          <MuiGrid container spacing={1}>
            <MuiGrid item xs={12} md={7}>
              <Header {...header} />
            </MuiGrid>
          </MuiGrid>
        </Box>
      )}
      <Alerts staticAlerts={alerts} />

      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: html }} />

      {actions && actions.length > 0 && (
        <Box className={classes.actionsContainer}>
          <MuiGrid container justify="flex-end">
            <HTMLPrinterActionsComponent actions={actions} />
          </MuiGrid>
        </Box>
      )}
    </div>
  );
};

export default HTMLPrinter;
